import React from "react";

const NewUserIcon = ({ size = 22, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="1.5"
      d="M11 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
    />
    <path
      fill={color}
      d="M11 12.75A6.25 6.25 0 0 1 17.25 19h1.5A7.75 7.75 0 0 0 11 11.25v1.5Zm0-1.5A7.75 7.75 0 0 0 3.25 19h1.5A6.25 6.25 0 0 1 11 12.75v-1.5Z"
    />
  </svg>
);

export default NewUserIcon;
